export default __webpack_public_path__ + "static/media/hmd_xl1.7beb0582.png";